'use client';
import Header from'@/components/common/Header';
 import HeroSection from'./HeroSection';
 import EventsSection from'./EventsSection';
 import PartnersSection from'./PartnersSection';
 import CommunitySection from'./CommunitySection';
 import FooterSection from'./FooterSection';
import MediaPartnerSection from './MediaPartnerSection';
import SpeakerSection from './SpeakerSection';
import GallerySection from './GallerySection';
import AboutSection from './contact/AboutSection';
import MissionVisionSection from './contact/MissionVisionSection';


export default function HomePage() {
  return (
    <main className="w-full bg-background-main">
      <Header />
      <HeroSection />
      <EventsSection />
      <SpeakerSection />
      <GallerySection />
      <PartnersSection />
      <MediaPartnerSection />
      {/* About Section */}
      <AboutSection />
      {/* Mission & Vision Section */}
      <MissionVisionSection />
      <CommunitySection />
      <FooterSection />
    </main>
  )
}